import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LifehkbkoverviewComponent } from './lifehkbkoverview.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';


const routes: Routes = [
  {
    path: '',
    component: LifehkbkoverviewComponent,
    data: {
      title: "About Us Overview",
      breadcrumb: "About Us Overview"
    }
  },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [],
  exports: [RouterModule]
})
export class LifehkbkoverviewRoutingModule { }